"use client"

import JobsAllLoadAll from "@/components/jobs/all-jobs/load-all"
import JobsAllJobsLoadMore from "@/components/jobs/all-jobs/load-more";
import { FeatureFlagCode } from "@/enums/feature-flag.enum";
import useFeatureFlags from "@/hooks/useFeatureFlags.hook";

const Jobs = () => {
    const { isFeatureEnabled } = useFeatureFlags();

    const isLoadMoreFlag = isFeatureEnabled(FeatureFlagCode.SCRL);
    
    return (
        isLoadMoreFlag ? <JobsAllJobsLoadMore /> : <JobsAllLoadAll />
    )  
}

export default Jobs